import React, { useEffect, useState } from "react";
import CountdownTimer from "../../templates/CountdownTimer";
import TextToSpeech from "../../templates/TextToSpeech.js";
import "../../index.css";
import Wave from "../../templates/Wave.jsx";

function ReadAssessment({ Exit, response, timeLeft, setTimeLeft }) {
  const [started, setStarted] = useState("intro");
  const [finished, setFinished] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!response || response.length === 0) return;
    if (started !== "ready") return;

    let currentIndex = 0;
    const interval = setInterval(() => {
      setIndex((prev) => {
        if (prev < response.length - 1) {
          currentIndex = prev + 1;
          return currentIndex;
        } else {
          clearInterval(interval);
          return prev;
        }
      });
    }, 12000);

    return () => clearInterval(interval);
  }, [response, started]);

  useEffect(() => {
    setIndex(0);
  }, [response]);

  useEffect(() => {
    if (timeLeft === 0) {
      setFinished(true);
    }
  }, [timeLeft]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-br from-gray-100 to-gray-200">
      {started && !finished && (
        <>
          {started === "intro" && (
            <div className="bg-white rounded-2xl shadow-2xl p-10 max-w-2xl border border-gray-200 text-center">
              <h1 className="text-3xl font-bold text-gray-800 mb-6">
                📖 Welcome to Paragraph Assessment
              </h1>
              <p className="text-3xl font-bold text-gray-800 mb-6">
                Read each sentence within{" "}
                <span className="text-red-600">12 seconds</span> to complete
                reading assessment
              </p>
              <TextToSpeech
                speech="Read each sentence within 12 seconds to complete reading assessment"
                onEnd={() => setStarted("ready")}
              />
            </div>
          )}

          {started === "ready" && (
            <div className="w-full max-w-3xl">
              {/* Header */}
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-semibold text-gray-700">
                  Section A
                </h2>
                <CountdownTimer
                  label="Time Remaining"
                  timeLeft={timeLeft}
                  setTimeLeft={setTimeLeft}
                />
              </div>

              {/* Card */}
              <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
                {/* Text */}
                <div className="text-center text-lg text-gray-800 font-medium mb-6">
                  {response && response.length > 0
                    ? response[index]
                    : "⏳ Waiting for text..."}
                </div>

                {/* Mic + Wave */}
                <div className="flex flex-col items-center space-y-4 bg-gray-50 rounded-xl border-2 border-gray-200 p-6 mb-6">
                  <div className="w-20 h-20 flex items-center justify-center bg-red-500 text-white rounded-full shadow-lg text-3xl animate-pulse">
                    🎤
                  </div>
                  <Wave color="red" />
                  <p className="text-gray-600 font-medium">
                    Speak clearly and confidently
                  </p>
                </div>

                {/* Footer */}
                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={() => setFinished(true)}
                    className="px-6 py-2 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-300 transition shadow-md"
                  >
                    Next Section
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* Finished Modal */}
      {finished && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl max-w-md w-full shadow-xl text-center space-y-6">
            {timeLeft !== 0 && (
              <button
                onClick={() => {
                  setFinished(false);
                  setStarted("ready");
                }}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-900 dark:hover:text-white text-3xl"
              >
                ✕
              </button>
            )}
            <p className="text-lg font-medium text-gray-800 dark:text-gray-200">
              🎉 You have completed Reading Assessment.
              <br /> Click <strong>Next</strong> to proceed for Next section.
            </p>
            <button
              type="button"
              onClick={Exit}
              className="px-6 py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300 transition"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReadAssessment;
